﻿/* https://brandplatform.smartphoto.com/general/organisms/promotion-bar/ */
import { createCollapsable } from "../molecules/collapsable";
import { initCountDown } from "../technical/countdown";
import { expressQuerySelector, expressQuerySelectorAll, isElementVisible } from "../../common/html";

export function createPromotionBar(containerEl: HTMLElement) {
	const showMore = expressQuerySelector<HTMLElement>(containerEl, ".technical-promotion-bar-showmore", false);
	if (showMore)
		createCollapsable(containerEl, {
			titleElSelector: ".technical-promotion-bar-header",
			scrollIntoViewAfterOpen: false,
			onBeforeOpen: async (): Promise<boolean> => {
				return isElementVisible(showMore);
			},
		});

	const countDownEls = expressQuerySelectorAll<HTMLElement>(containerEl, ".technical-countdown");
	countDownEls.forEach((el) => {
		const countDownToDate = el.dataset.countdown || "";
		const daysLabel = el.dataset.dayslabel || "";
		const dayLabel = el.dataset.daylabel || "";

		if (countDownToDate !== "") {
			const onCountDownFinish = () => {
				const parent = containerEl.parentElement;
				if (parent) parent.removeChild(containerEl);
			};

			initCountDown(containerEl, el, countDownToDate, {
				showDays: true,
				onCountDownFinish: onCountDownFinish,
				daysLabel,
				dayLabel,
			});
		}
	});
}
